import Vue from 'vue'
import Element from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'
import '@/theme/element-#42B983/index.css'

Vue.use(Element)
